import axios from "./axios-config";

export const getAllUsers = async (keyword, page) => {

    let { data } = await axios.get(`/super-admin/users?keywords=${keyword ?? ""}&page=${page}`)
    return (data);

}
export const getAllUsersWithoutPaginate = async () => {

    let { data } = await axios.get(`/super-admin/users?type=all`)
    return (data);

}

export const getSingleUser = async (id) => {

    let { data } = await axios.get(`/super-admin/users/` + id)
    return data;

}
export const deleteSingleUser = async (id) => {
    let { data } = await axios.delete(`/super-admin/users/` + id)
    return data;
}

export const updateSingleUsers = async (updateData) => {

    let { data } = await axios.post(`/super-admin/users/${updateData.id}?_method=put`, updateData.data)
    return data;
}

export const storeSingleUsers = async (storeData) => {

    let { data } = await axios.post(`/super-admin/users`, storeData)
    return data
}


// export const getUserUsers = async (data) => {
//     let { data } =  await axios.post(`/super-admin/Users/all/blogs`, data)
//     return data;
// }

// export const getWorkshopUsers = async (data) => {
//     try {
//         let response = await axios.post(`/super-admin/Users/all/users`, data)
//         return (response.data);
//     } catch (error) {
//         return (error);
//     }
// }

